var map = {
	"./button/BaseButton.vue": "9UZK",
	"./dialog/BaseDialog.vue": "X2Dh",
	"./skeleton/Skeleton.vue": "7ECP",
	"./skeleton/SkeletonItem.vue": "ibX+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oCUD";


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents \.vue$/
// module id = oCUD
// module chunks = 1